import { getProductCategories } from "@dillon/Services/CommonServices";
import { setGA4Event } from "@dillon/Store/Handlers/Utilities/CustomTracking";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, ExecuteOnSuccessCallback } from "@insite/client-framework/Store/Pages/OrderHistory/Handlers/Reorder";

addToChainAfter(chain, ExecuteOnSuccessCallback, async props => {
    const resultCategories = await getProductCategories({
        productIds:
            props.apiParameter.cartLines
                ?.filter(line => line.productId !== null && line.productId !== undefined)
                .map(line => line.productId!) || [], // Ensure productIds is always an array
        type: "product",
    });

    if (resultCategories.successful) {
        const productCategories = resultCategories.result;
        const qtysOrdered = props.apiParameter.cartLines;

        if (props.apiResult?.cartLines?.cartLines) {
            setGA4Event(props.apiResult?.cartLines?.cartLines, "add_to_cart", {
                productCategories,
                qtysOrdered,
            });
        }
    }
});
